export const buildCustomerContactOptions = (clientContacts) => (
  (Array.isArray(clientContacts) ? clientContacts : []).filter((contact) => !contact?.mergedIntoContactId).map((contact) => {
    const safeName = `${contact?.firstName || ''} ${contact?.lastName || ''}`.trim();
    const value = contact?.contactId || contact?.id || '';
    return {
      ...contact,
      id: value,
      name: !safeName || safeName === 'undefined undefined'
        ? (contact?.email || value)
        : safeName,
    };
  })
);
